/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect } from 'react';

// local imports
import { PharmacyService } from 'app/services';
import useDataApi from '../../../use-data-api';
import { FormatUtils, Mapper, TableUtils } from 'app/utils';
import { AddButton } from 'app/components/atoms';

const usePharmacySupportListService = (queries, isFilteringRef, openModal) => {
  const [service, setService] = useDataApi();

  const detailBtn = id => (
    <AddButton label="Görüntüle" icon="open_in_new" onAddNewRecord={() => openModal(id)} />
  );

  const fetchData = useCallback(async () => {
    const supportFormList = await PharmacyService.getPharmacySupportList(queries);
    const contactForms = supportFormList.data.data;

    const out = contactForms?.map(item => {
      const { id, pharmacy, created_at, subject, ...rest } = item;

      return {
        ...rest,
        pharmacy_name: pharmacy?.name,
        subject: Mapper.customerSupportSubjects(subject.id),
        created_at: FormatUtils.convertDateString(created_at),
        detail_btn: detailBtn(id)
      };
    });

    isFilteringRef.current = false;

    return {
      table: {
        columns: TableUtils.supportFormList,
        rows: out
      },
      totalCount: supportFormList?.data?.total_count,
      total: Math.round(supportFormList?.data?.total_count / parseInt(queries.limit))
    };
  }, [queries]);

  useEffect(() => setService(() => fetchData()), [setService, fetchData]);

  const handleRefresh = async () => {
    setService(() => fetchData());
  };

  return {
    service,
    handleRefresh
  };
};

export default usePharmacySupportListService;
